import React from "react";
import styled from "styled-components";
import TopNavbar from "../components/Nav/TopNavbar";
import Footer from "../components/Sections/Footer";

const workshops = [
  {
    id: 1,
    title: "סדנת יומן ויזואלי",
    emoji: "📒",
    date: "תאריך ___",
    time: "שעה ___",
    location: "מיקום ___",
    spots: "__ מקומות",
    bg: "var(--tint-rose)",
    description:
      "פותחים מחברת ומתחילים מסע: כותבים, מציירים, גוזרים, מדביקים. בסדנה הזו תיצרי לעצמך יומן ויזואלי שמלווה אותך בחיי היומיום.",
  },
  {
    id: 2,
    title: "סדנת קלפי נפש",
    emoji: "🃏",
    date: "תאריך ___",
    time: "שעה ___",
    location: "מיקום ___",
    spots: "__ מקומות",
    bg: "var(--tint-butter)",
    description:
      "בסדנה הזו תיצרי קלפים אישיים משלך, עם מילים, דימויים וצבעים שמדברים בדיוק בשפה שלך. לא צריך ניסיון יצירתי, רק לב פתוח.",
  },
  {
    id: 3,
    title: "סדנת לוח חזון",
    emoji: "🌟",
    date: "תאריך ___",
    time: "שעה ___",
    location: "מיקום ___",
    spots: "__ מקומות",
    bg: "var(--tint-rose)",
    description:
      "בסדנה הזו תיצרי לוח חזון אישי שמשקף את החלומות, המטרות והשאיפות שלך. תלי אותו במקום שתראי כל יום ותרגישי את ההבדל.",
  },
];

export default function WorkshopsPage({ navigate }) {
  return (
    <>
      <TopNavbar navigate={navigate} currentPage="workshops" />

      {/* ===== HERO ===== */}
      <PageHero className="pageHero">
        <div className="container flexSpaceCenter">
          <HeroText className="hero-in">
            <PageTag className="pinkBg whiteColor radius6">הסדנאות שלנו</PageTag>
            <h1 className="font60 extraBold darkColor heroTitle" style={{ marginTop: "15px", lineHeight: "1.1" }}>
              סדנאות 🌸
            </h1>
            <p className="font18 darkColor" style={{ marginTop: "20px", lineHeight: "1.7", maxWidth: "500px" }}>
              מפגשים קטנים, חוויה גדולה.
              בואי ליצור, להרגיש ולהתחבר לעצמך
              בסביבה חמה ותומכת.
            </p>
          </HeroText>
          <HeroImageBox>
            {/* IMAGE PLACEHOLDER — swap for a workshop group photo */}
            <HeroImgPlaceholder className="radius8">
              <span>📸 תמונת גיבור: סדנה</span>
            </HeroImgPlaceholder>
          </HeroImageBox>
        </div>
      </PageHero>

      {/* ===== UPCOMING WORKSHOPS ===== */}
      <Section className="lightBg">
        <div className="container">
          <SectionHeader>
            <h2 className="font40 extraBold darkColor">סדנאות קרובות 📅</h2>
            <p className="font15 greyColor">הרשמי מוקדם, המקומות מוגבלים</p>
          </SectionHeader>
          <WorkshopsList className="stagger-reveal">
            {workshops.map((w) => (
              <WorkshopCard key={w.id} className="radius8">
                <WorkshopImgBox>
                  {/* IMAGE PLACEHOLDER — swap for a photo of this workshop type */}
                  <WorkshopImg style={{ background: w.bg }}>
                    <span>📸 תמונת סדנה: {w.title}</span>
                  </WorkshopImg>
                </WorkshopImgBox>
                <WorkshopBody>
                  <WorkshopEmoji>{w.emoji}</WorkshopEmoji>
                  <h3 className="font25 extraBold darkColor" style={{ margin: "8px 0 16px" }}>
                    {w.title}
                  </h3>
                  <WorkshopMeta>
                    <MetaItem>
                      <MetaIcon>📅</MetaIcon>
                      <span className="font14">{w.date} | {w.time}</span>
                    </MetaItem>
                    <MetaItem>
                      <MetaIcon>📍</MetaIcon>
                      <span className="font14">{w.location}</span>
                    </MetaItem>
                    <MetaItem>
                      <MetaIcon>👥</MetaIcon>
                      <span className="font14">{w.spots}</span>
                    </MetaItem>
                  </WorkshopMeta>
                  <p className="font14" style={{ lineHeight: "1.8", color: "var(--ink-soft)", margin: "18px 0 22px" }}>
                    {w.description}
                  </p>
                  <RegisterBtn
                    onClick={() => navigate("contact")}
                    className="pinkBg whiteColor radius8 pointer semiBold font15"
                  >
                    להרשמה ←
                  </RegisterBtn>
                </WorkshopBody>
              </WorkshopCard>
            ))}
          </WorkshopsList>
        </div>
      </Section>

      {/* ===== WHAT TO EXPECT ===== */}
      <Section>
        <div className="container">
          <TwoCol>
            <TextCol>
              <SectionLabel className="font15 semiBold" style={{ color: "var(--rose-600)" }}>מה מחכה לך</SectionLabel>
              <h2 className="font40 extraBold darkColor" style={{ margin: "10px 0 20px" }}>
                איך נראית סדנה?
              </h2>
              <BodyText className="font15">
                הסדנאות שלנו הן מפגשים קטנים ואינטימיים, בדרך כלל קבוצה של עד __ משתתפות.
              </BodyText>
              <BodyText className="font15" style={{ marginTop: "14px" }}>
                האווירה חמה, הקצב שלך, ואין "נכון" או "לא נכון". את מגיעה כמו שאת,
                ויוצאת עם משהו שנוצר מהלב.
              </BodyText>
              <ExpectList>
                <ExpectItem>✅ חומרים כלולים</ExpectItem>
                <ExpectItem>✅ הדרכה צמודה</ExpectItem>
                <ExpectItem>✅ אווירה תומכת</ExpectItem>
                <ExpectItem>✅ קפה ועוגה 🍰</ExpectItem>
                <ExpectItem>✅ הביתה עם יצירה משלך</ExpectItem>
              </ExpectList>
            </TextCol>
            <ImageCol>
              <ImgStack>
                {/* IMAGE PLACEHOLDER — workshop atmosphere photo */}
                <ImgPlaceholder className="radius8" style={{ background: "var(--tint-rose)", height: "300px" }}>
                  <span>📸 אווירת סדנה</span>
                </ImgPlaceholder>
                <ImgRowSmall>
                  {/* IMAGE PLACEHOLDER — materials close-up */}
                  <SmallImg className="radius8" style={{ background: "var(--tint-butter)" }}>
                    <span>📸 חומרים</span>
                  </SmallImg>
                  {/* IMAGE PLACEHOLDER — participants working */}
                  <SmallImg className="radius8" style={{ background: "var(--tint-mauve)" }}>
                    <span>📸 משתתפות</span>
                  </SmallImg>
                </ImgRowSmall>
              </ImgStack>
            </ImageCol>
          </TwoCol>
        </div>
      </Section>

      {/* ===== PHOTO GALLERY ===== */}
      <GallerySection className="coralBg">
        <div className="container">
          <SectionHeader>
            <h2 className="font30 extraBold darkColor">רגעים מהסדנאות 📷</h2>
          </SectionHeader>
          <GalleryGrid className="stagger-reveal">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <GalleryItem key={i} className="radius8" style={{ background: i % 2 === 0 ? "var(--tint-butter)" : "var(--tint-paper)" }}>
                {/* IMAGE PLACEHOLDER — real workshop photos */}
                <span>📸 סדנה {i}</span>
              </GalleryItem>
            ))}
          </GalleryGrid>
        </div>
      </GallerySection>

      {/* ===== TESTIMONIALS ===== */}
      <Section>
        <div className="container">
          <SectionHeader>
            <h2 className="font30 extraBold darkColor">מה אמרו המשתתפות 💬</h2>
          </SectionHeader>
          <TestimonialsGrid className="stagger-reveal">
            {[1, 2, 3].map((i) => (
              <TestimonialCard key={i} className="lightBg radius8">
                {/* IMAGE PLACEHOLDER — participant headshot */}
                <TestimonialAvatar style={{ background: i % 2 === 0 ? "var(--tint-butter)" : "var(--tint-rose)" }}>
                  <span>📸</span>
                </TestimonialAvatar>
                <TestimonialText className="font14">
                  {/* TEXT PLACEHOLDER — real testimonial */}
                  "כאן תוכלי לשים ציטוט אמיתי של משתתפת שהייתה בסדנה. משהו קצר, כן ומרגש."
                </TestimonialText>
                <TestimonialName className="font13 semiBold" style={{ color: "var(--rose-600)", marginTop: "12px" }}>
                  {/* TEXT PLACEHOLDER */}שם משתתפת {i}
                </TestimonialName>
              </TestimonialCard>
            ))}
          </TestimonialsGrid>
        </div>
      </Section>

      {/* ===== CONTACT / REGISTER CTA ===== */}
      <RegisterSection className="pinkBg">
        <div className="container">
          <RegisterInner>
            <RegisterTextSide>
              <h2 className="font40 extraBold whiteColor">רוצה להירשם? 🌸</h2>
              <p className="font15 whiteColor" style={{ marginTop: "15px", lineHeight: "1.8", maxWidth: "420px" }}>
                שלחי לי הודעה עם שם הסדנה שמעניינת אותך ואחזור אלייך בהקדם עם פרטים והרשמה.
              </p>
              <ContactDetails>
                <ContactItem className="whiteColor font15">
                  {/* TEXT PLACEHOLDER */}
                  📧 carmela0208@gmail.com
                </ContactItem>
                <ContactItem className="whiteColor font15">
                  {/* TEXT PLACEHOLDER */}
                  💬 וואטסאפ: 050-000-0000
                </ContactItem>
                <ContactItem className="whiteColor font15">
                  {/* TEXT PLACEHOLDER */}
                  📸 אינסטגרם: @your_handle
                </ContactItem>
              </ContactDetails>
              <RegisterCTABtn
                onClick={() => navigate("contact")}
                className="greenBg darkColor radius8 pointer semiBold font15"
              >
                לטופס יצירת קשר ←
              </RegisterCTABtn>
            </RegisterTextSide>
            <RegisterImageSide>
              {/* IMAGE PLACEHOLDER — inviting workshop photo */}
              <RegisterImg className="radius8">
                <span>📸 תמונה: הזמנה לסדנה</span>
              </RegisterImg>
              {/* IMAGE PLACEHOLDER — second photo */}
              <RegisterImgSmall className="radius8" style={{ background: "var(--tint-paper)" }}>
                <span style={{ color: "var(--tint-paper)" }}>📸 תמונה נוספת</span>
              </RegisterImgSmall>
            </RegisterImageSide>
          </RegisterInner>
        </div>
      </RegisterSection>

      <Footer navigate={navigate} />
    </>
  );
}

/* ---- Styled Components ---- */
const PageHero = styled.section`
  padding: 120px 0 80px;
  direction: rtl;
  @media (max-width: 860px) {
    padding: 100px 0 60px;
    .flexSpaceCenter { flex-direction: column; gap: 40px; }
  }
`;
const HeroText = styled.div`
  width: 55%;
  @media (max-width: 860px) { width: 100%; }
`;
const PageTag = styled.span`
  display: inline-block;
  padding: 5px 14px;
  font-size: 0.813rem;
  font-weight: 600;
`;
const HeroImageBox = styled.div`
  width: 40%;
  @media (max-width: 860px) { width: 100%; }
`;
const HeroImgPlaceholder = styled.div`
  width: 100%;
  height: 340px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  font-weight: 600;
  background: var(--grad-blush);
  color: var(--rose-600);
  border: 8px solid rgba(255, 255, 255, 0.7);
  box-shadow: var(--shadow-lift);
  animation: float 7s ease-in-out infinite;
`;
const Section = styled.section`
  padding: 80px 0;
  direction: rtl;
`;
const SectionHeader = styled.div`
  text-align: center;
  margin-bottom: 50px;
  p { margin-top: 10px; }
`;
const SectionLabel = styled.p``;
const WorkshopsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
`;
const WorkshopCard = styled.div`
  display: flex;
  background: var(--glass-strong);
  backdrop-filter: blur(6px);
  box-shadow: var(--shadow-card);
  overflow: hidden;
  transition: transform 0.6s var(--ease-spring), box-shadow 0.6s var(--ease-out);
  &:hover { transform: translateY(-8px); box-shadow: var(--shadow-lift); }
  @media (max-width: 760px) { flex-direction: column; }
`;
const WorkshopImgBox = styled.div`
  width: 320px;
  flex-shrink: 0;
  @media (max-width: 760px) { width: 100%; height: 200px; }
`;
const WorkshopImg = styled.div`
  width: 100%;
  height: 100%;
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.938rem;
  font-weight: 600;
  color: var(--ink);
`;
const WorkshopBody = styled.div`
  padding: 30px 35px;
  flex: 1;
`;
const WorkshopEmoji = styled.div`
  font-size: 2rem;
`;
const WorkshopMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
`;
const MetaItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  background: var(--rose-100);
  padding: 5px 12px;
  border-radius: 2rem;
`;
const MetaIcon = styled.span`
  font-size: 0.875rem;
`;
const RegisterBtn = styled.button`
  padding: 12px 24px;
  border: none;
  cursor: pointer;
`;
const TwoCol = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 60px;
  @media (max-width: 860px) { flex-direction: column; }
`;
const TextCol = styled.div`
  flex: 1;
`;
const ImageCol = styled.div`
  flex: 1;
`;
const BodyText = styled.p`
  line-height: 1.8;
  color: var(--ink-soft);
`;
const ExpectList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 25px;
`;
const ExpectItem = styled.span`
  font-size: 0.938rem;
  font-weight: 600;
  color: var(--ink);
`;
const ImgStack = styled.div``;
const ImgRowSmall = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 12px;
`;
const ImgPlaceholder = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.938rem;
  font-weight: 600;
  color: var(--ink);
`;
const SmallImg = styled.div`
  flex: 1;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--ink);
`;
const GallerySection = styled.section`
  padding: 80px 0;
  direction: rtl;
`;
const GalleryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  @media (max-width: 600px) { grid-template-columns: repeat(2, 1fr); }
`;
const GalleryItem = styled.div`
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--ink);
`;
const TestimonialsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 25px;
  @media (max-width: 760px) { grid-template-columns: 1fr; }
`;
const TestimonialCard = styled.div`
  padding: 28px;
  text-align: center;
  box-shadow: var(--shadow-card);
`;
const TestimonialAvatar = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
  margin: 0 auto 15px;
`;
const TestimonialText = styled.p`
  line-height: 1.8;
  color: var(--ink-soft);
  font-style: italic;
`;
const TestimonialName = styled.p``;
const RegisterSection = styled.section`
  padding: 80px 0;
  direction: rtl;
`;
const RegisterInner = styled.div`
  display: flex;
  gap: 60px;
  align-items: flex-start;
  @media (max-width: 860px) { flex-direction: column; }
`;
const RegisterTextSide = styled.div`
  flex: 1;
`;
const ContactDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin: 25px 0 30px;
`;
const ContactItem = styled.p`
  opacity: 0.9;
`;
const RegisterCTABtn = styled.button`
  padding: 14px 30px;
  font-size: 1rem;
  border: none;
  cursor: pointer;
`;
const RegisterImageSide = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
const RegisterImg = styled.div`
  width: 100%;
  height: 280px;
  background: rgba(255, 255, 255, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.938rem;
  font-weight: 600;
  color: var(--rose-700);
  border: 2px dashed rgba(203, 29, 133, 0.45);
`;
const RegisterImgSmall = styled.div`
  width: 100%;
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.875rem;
  font-weight: 600;
  border: 2px dashed rgba(203, 29, 133, 0.45);
  border-radius: 1rem;
`;
